// extracted by mini-css-extract-plugin
export var avatar = "_hb-3";
export var avatarContainer = "_hb-2";
export var avatarSpacer = "_hb-5";
export var avatarSpacerContainer = "_hb-4";
export var avatarStackContainer = "_hb-1";
export var bubble = "_hb-0";
export var remainderBubble = "_hb-6";